import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class parametroService {
    
    /******* QUERIES ******/

    async paginacionEmpresaParametro(filter) {
        const response = await axios
            .get(`${ERP}integracion/parametro/paginacion?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerEmpresaParametroPorId(id) {
        const response = await axios
            .get(`${ERP}integracion/parametro/empresa-parametro?id=${id}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    /******* TRANSACCIONES ******/

    async modificarEmpresaParametro(data) {
        const response = await axios
            .put(`${ERP}integracion/parametro/modificar-empresa-parametro`, data)
            .then(response => { 
                return response; 
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    }; 
}

export default new parametroService();